import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { coherentDirectDebitStyles as styles } from './styles-direct-debit';
import { Grid, MenuItem, Select, TextField, Typography, withStyles } from '@material-ui/core';
import { FieldContainer, FieldLabel } from '../../common/FieldContainer';
// import Select from '../../common/Select';
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import Moment from 'moment';
import { getDateNoTimezone } from '../../../collums-components/helpers/timezone';
import DateFnsUtils from '@date-io/date-fns';
import enLocale from 'date-fns/locale/en-GB/index';

const CoherentDirectDebitForm = ({ classes, customerData, paymentValue, invoice, setDdData }) => {
    const minDaysAhead = 0;
    const defaultQuantity = 12;
    const [quantity, setQuantity] = useState(defaultQuantity);
    const [chosenPaymentValue, setChosenPaymentValue] = useState(paymentValue);
    const [monthlyPaymentValue, setMonthlyPaymentValue] = useState((paymentValue / defaultQuantity).toFixed(2));
    const [firstPaymentDate, setFirstPaymentDate] = useState(
        Moment()
            .add(minDaysAhead, 'days')
            .toDate()
    );
    const quantityOptions = Array.from(new Array(24), (_, i) => ({
        label: `${i + 1}`,
        value: `${i + 1}`
    }));

    const updateDdData = (quantity, firstPaymentDate, monthlyPaymentValue) => {
        setDdData({
            firstPayment: firstPaymentDate,
            amount: monthlyPaymentValue,
            numberOfPayments: quantity
        });
    };

    const updateMonthlyPayment = (paymentValue, quantity) => {
        const monthlyPaymentValue = (paymentValue / quantity).toFixed(2);
        setMonthlyPaymentValue(monthlyPaymentValue);
    };

    useEffect(() => {
        updateDdData(quantity, firstPaymentDate, monthlyPaymentValue);
        // eslint-disable-next-line
    }, [quantity, firstPaymentDate, monthlyPaymentValue]);

    return (
        <div style={{ marginTop: 20 }}>
            <div className={classes.header} style={{ textAlign: 'center', fontWeight: 500 }}>
                Create New Direct Debit
            </div>

            <form>
                <Grid container style={{ padding: '25px 120px' }}>
                    <FieldContainer lg={12} spacing={0} styles={{ padding: '0 0 10px 0' }}>
                        <FieldLabel lg={6}>Name: {`${customerData?.firstName} ${customerData?.surname}`}</FieldLabel>
                        {invoice?.code && <FieldLabel lg={6}>Invoice: {`${invoice.code}`}</FieldLabel>}
                    </FieldContainer>
                    <FieldContainer lg={12} spacing={0} styles={{ padding: '10px 0' }}>
                        <FieldLabel lg={6}>Total amount:</FieldLabel>
                        <Grid item lg={6}>
                            <TextField
                                style={{ width: '100%' }}
                                value={chosenPaymentValue}
                                onChange={event => {
                                    const value = event.target.value;
                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                        setChosenPaymentValue(value);
                                        updateMonthlyPayment(value, quantity);
                                    }
                                }}
                            />
                        </Grid>
                    </FieldContainer>
                    <FieldContainer lg={12} spacing={0} styles={{ padding: '10px 0' }}>
                        <FieldLabel lg={6}>No of monthly payments:</FieldLabel>
                        <Grid item lg={6}>
                            <Select
                                style={{ width: '100%' }}
                                value={quantity}
                                onChange={event => {
                                    updateMonthlyPayment(chosenPaymentValue, event.target.value);
                                    setQuantity(event.target.value);
                                }}
                            >
                                {quantityOptions.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </FieldContainer>

                    <FieldContainer lg={12} spacing={0} styles={{ padding: '10px 0' }}>
                        <FieldLabel lg={6}>Date of first payment:</FieldLabel>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enLocale} lg={6}>
                            <DatePicker
                                variant={'outlined'}
                                autoOk
                                className={`${classes.font} ${classes.hiddenCalendarIcon}`}
                                keyboard
                                name="dateOfBirth"
                                placeholder="dd/mm/yyyy"
                                format={'dd/MM/yyyy'}
                                required
                                mask={value =>
                                    value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : []
                                }
                                value={firstPaymentDate}
                                onChange={value => {
                                    if (!value) return;

                                    const date = Moment.utc(getDateNoTimezone(value));

                                    setFirstPaymentDate(date);
                                }}
                                minDate={Moment()
                                    .add(minDaysAhead, 'days')
                                    .toDate()}
                                // disableOpenOnEnter
                                animateYearScrolling={false}
                            />
                        </MuiPickersUtilsProvider>
                    </FieldContainer>
                    <FieldContainer lg={12} spacing={0} styles={{ padding: '10px 0' }}>
                        <FieldLabel lg={6}>Monthly payment amount amount:</FieldLabel>
                        <Typography lg={6}>£{monthlyPaymentValue}</Typography>
                    </FieldContainer>
                </Grid>
            </form>

            <div>
                Clicking &quot;Create Direct Debit&quot; will send an email to your client with a link to set up the
                Direct Debit. Once submitted, £1.00 will be taken from their account confirming the DD. The first
                payment will then be taken less the £1.00.
            </div>
        </div>
    );
};

CoherentDirectDebitForm.propTypes = {
    classes: PropTypes.object.isRequired,
    customerData: PropTypes.object.isRequired,
    paymentValue: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    invoice: PropTypes.object.isRequired,
    setDdData: PropTypes.func
};
export default withStyles(styles)(CoherentDirectDebitForm);
